import type { SuperSource } from '../super'

export function superSourceToIconUrl(source: SuperSource): string {
  const fileName = source.toString().toLowerCase().replace(/ /g, '_')
  return `https://storage.googleapis.com/slite-cdn/logos/colored/${fileName}_mark.svg`
}
